<template>
<div class='cjwt'>
    <p class="title">常见问题</p>
    <el-collapse v-model="activeNames">
        <el-collapse-item title="使用平台，对电脑系统及软件具体有哪些要求？" name="1">
            <div>1、操作系统要求：win7及以上版本操作系统。</div>
            <div>2、浏览器要求：IE浏览器（10及以上）、360浏览器（极速模式），以上浏览器任一即可，请尽量使用上述浏览器。</div>
            <div>3、其他软件： flash插件、Microsoft Word 2007及以上版本、PDF阅读器，以上软件请用户自行下载。</div>
        </el-collapse-item>
        <el-collapse-item title="新用户进入京东招标采购平台完成企业申报后多长时间完成审核？且如何确认审核是否通过？" name="2">
            <div>1、平台工作人员收到企业申报信息后会在1个工作日之内完成审核，是否审核通过，均有短信通知用户，请关注短信，谢谢!</div>
            <div>2、已通过审核的企业，可正常参与项目报名；未通过审核的企业请登录平台查看原因，并进行修改。</div>
        </el-collapse-item>
        <el-collapse-item title="CA数字证书费用是多少？有效期多久？作用是什么？" name="3">
            <div>参与项目投标之前需先申领CA数字证书，费用是300/年，有效期是一年；CA数字证书是对企业的身份认证，在招投标项目过程中，用于加盖电子签章、对标书进行加密、开标解密等功能。</div>
        </el-collapse-item>
        <el-collapse-item title="用户已经报名，页面显示已经报名，但项目流程内容走不下去（已报名的项目在哪查看）？" name="4">
            <div>已报名的项目在项目管理-投标项目管理-选择已报名的项目-勾选进入项目流程查看。</div>
        </el-collapse-item>
        <el-collapse-item title="如何制作电子投标文件？" name="5">
            <div>根据招标文件要求做好pdf版本，再使用投标编制工具进行上传生成电子加密标书。在平台中按照提示会链接至配套的投标编制工具，操作手册详见投标编制工具页面。</div>
        </el-collapse-item>
        <el-collapse-item title="投标文件上传后是否可以修改？" name="6">
            <div>在投标文件截止时间之前，都可以上传。如已上传，可重新上传新的标书，会覆盖原先的标书，以最新上传的文件为准。</div>
        </el-collapse-item>
        <el-collapse-item title="投标单位参加电子开标活动需要注意哪些事项？" name="7">
            <div>1、在开标前及时上传有效电子标书至交易平台</div>
            <div>2、请携带编制电子投标书的CA锁</div>
            <div>3、注意在开标主持人的引导下，使用CA锁进行电子签到、标书解密</div>
            <div>4、建议携带备份投标文件（以备解密失败补救）</div>
            <div>5、携带至开标现场的纸质投标文件需从投标工具中导出打印</div>
        </el-collapse-item>
        <el-collapse-item title="如用户咨询招标文件的相关内容，比如标书里的授权代表签字？装订需要成一册？或其他相关等？" name="8">
            <div>请用户联系招标人或代理公司咨询。</div>
        </el-collapse-item>
    </el-collapse>
</div>
</template>
<script>
export default {
    name:'center',
    data(){
        return{
            activeNames:'1'
        }

    }
}
</script>
<style lang="less">
.help .helpContent > div{
    text-align: left;
    padding: 0;
}
.cjwt{
.el-collapse{
    border-top-style: dashed;
    border-bottom-style: dashed;
}
.el-collapse-item__header{
    border-bottom-style: dashed;
    height:78px;
    line-height: 78px;
    padding:0 20px 0 50px;
    position: relative;
    color: #666;
    font-weight: bold;
    font-size: 14px;
}
.el-collapse-item__header:before{
    content:'';
    display: block;
    position: absolute;
    left:20px;
    top:31px;
    width: 16px;
    height:16px;
    background: url('../assets/help/q.png');
}
.el-collapse-item__content{
    padding-left:50px;
    padding-right:50px;
    position: relative;
    font-size: 14px;
    line-height: 32px;
    color:#999;
}
.el-collapse-item__content:before{
    content:'';
    display: block;
    position: absolute;
    left:20px;
    top:8px;
    width: 16px;
    height:16px;
    background: url('../assets/help/a.png');
}
}
</style>